<template>
  <div>
    <Header class="yh-header" active="/ovop" :productValue="'5'"/>
    <div style="height: 70px"></div>
    <ProvinceCitySelect class="container" @change="onProvinceCityChange" />
    <el-container class="container">
      <el-aside width="240px">
        <ProductCategoryVerticalSelect :active="categoryCode" @selected="onCategoryCode" />
      </el-aside>
      <el-main>
        <OneVillageOneProductPage @change="onPageChange" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import ProductCategoryVerticalSelect from "@/components/ProductCategoryVerticalSelect.vue";
import OneVillageOneProductPage from "@/components/OneVillageOneProductPage.vue";
import ProvinceCitySelect from "@/components/ProvinceCitySelect";
export default {
  name: "ProductHome",
  components: {
    Header,
    ProductCategoryVerticalSelect,
    OneVillageOneProductPage,
    ProvinceCitySelect
  },
  data() {
    return {
      placeProvince: "",
      placeCity: "",
      categoryCode: "",
      pageNum: 1,
      numPerPage: 20,
      importStatus:''
    };
  },
  created() {
    if (this.$route.query.categoryCode) {
      this.categoryCode = this.$route.query.categoryCode;
    }
    this.$store.dispatch("productCategoryPage", {
      packageName: "product",
      className: "productCategory",
      methodName: "retrieve",
      params: {
        numPerPage: 1000,
        withCountByType:'OneVillageOneProduct'
      }
    });

    this.$store.dispatch("oneVillageOneProductPage", {
      packageName: "ovop",
      className: "oneVillageOneProduct",
      methodName: "retrieve",
      params: {
        numPerPage: 20,
        categoryCode: this.categoryCode
      }
    });

    this.ajax.doPost({
      packageName: "user",
      className: "userAnalysis",
      methodName: "create",
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: "一村一品-查询",
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    });
  },
  methods: {
    onProvinceCityChange(e) {
      this.placeProvince = e.province;
      this.placeCity = e.city;
      this.importStatus = e.statusValue
      this.onChange();
    },
    onCategoryCode(e) {
      this.categoryCode = e;

      this.onChange();
    },
    onPageChange(e) {
      this.pageNum = e;

      this.onChange();
    },
    onChange() {
      this.$store.dispatch("oneVillageOneProduct", {
        packageName: "ovop",
        className: "oneVillageOneProduct",
        methodName: "retrieve",
        params: {
          placeProvince: this.placeProvince,
          placeCity: this.placeCity,
          categoryCode: this.categoryCode,
          pageNum: this.pageNum,
          numPerPage: this.numPerPage,
          importStatus:this.importStatus
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1140px;
  margin: 20px auto;
}
.pcs {
  width: 1140px;
  margin: 20px auto;
}
</style>
